import React, { useEffect, useRef, useState } from 'react'
import './space-range.less'
import { useParams } from 'react-router-dom'
import { getGroupsByBuildingUuid } from '@/api/spec-common/group';
import { Group } from '@/commons/interface/speccommon/group';
import classNames from 'classnames';
import { graphicStore } from '@/commons/store/graphic-store';
import { RenderGroupType } from '@/commons/enums/render-group-type';
import { GroupType } from 'tnbimbase';
import { drawEntitiesBoundingBox, showEntities } from '@/commons/utils/show-entity';
import { TnGroupContext } from '@/commons/context/group-store';
import { PYTHA_SINGAL } from '@/passets/pytha-engine/enums/pytha-signal';
import { ReactComponent as BlueDownSvg } from './icons/blue-down.svg';
import { ReactComponent as GrayDownSvg } from './icons/gray-down.svg';
import { ReactComponent as BlueLeftSvg } from './icons/blue-left.svg';
import { ReactComponent as GrayLeftSvg } from './icons/gray-left.svg';

export default function SpaceRangePanel() {
    const { projectUuid, buildingUuid } = useParams();

    const [groups, setGroups] = useState<Group[]>([])

    // const [groupsR1, setGroupsR1] = useState<Group[]>([]);
    // const [groupsRx, setGroupsRx] = useState<Group[]>([]);

    // const [currentSpaceR1, setCurrentSpaceR1] = useState<Group>();
    const [currentSpaceRx, setCurrentSpaceRx] = useState<Group>();

    const [treeList, setTreeList] = useState<Group[]>([]);
    // const helpBoxRef = useRef(null);


    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore.extraContext.listeners.getSignal(PYTHA_SINGAL.onCreateHelpBoxFinish).add(onCreateHelpBoxFinish);
        graphicStore.extraContext.listeners.signals.onProcessEscape.add(onProcessEscape);

        return () => {
            if (!graphicStore.extraContext.getCurrentViewEditor()) return;
            graphicStore.extraContext.listeners.signals.onProcessEscape.remove(onProcessEscape);
            graphicStore.extraContext.listeners.getSignal(PYTHA_SINGAL.onCreateHelpBoxFinish).remove(onCreateHelpBoxFinish);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    useEffect(() => {
        clearState();
        if (!buildingUuid) return;

        getGroupsByBuildingUuid(projectUuid, buildingUuid).then(res => {
            let data: Group[] = res.data || [];
            data = data?.map(item => {
                item.hidden = true;
                return item;
            })
            setGroups(data);
        }).catch(err => {
            let g: Group[] = [
                { uuid: '0', name: '整楼', level: 1 },
                { uuid: '1', name: '1F', level: 1 },
                { uuid: '2', name: '2F', level: 1 },
                { uuid: '3', name: '2F(夹)', level: 1 },
                { uuid: '4', name: '3F', level: 1 },
                { uuid: '5', name: '4F', level: 1 },
                { uuid: '6', name: '5F', level: 1 },
                { uuid: '7', name: '贵宾候车厅', level: 2, parentUuid: '1' },
                { uuid: '8', name: '软席候车厅', level: 2, parentUuid: '1' },
                { uuid: '9', name: '卫生间a', level: 3, parentUuid: '7' },
                { uuid: '10', name: '卫生间B', level: 3, parentUuid: '7' },
            ];
            setGroups(g);
        })
    }, [buildingUuid])

    useEffect(() => {
        if (groups?.length === 0) {
            clearState();
            return;
        }
        let treeList: Group[] = buildTree(groups);
        let buildingGroup = {
            id: 0,
            uuid: 'building',
            name: '整楼',
            projectUuid: projectUuid,
            parentUuid: null,
            buildingUuid: buildingUuid,

            children: [],
            level: 1,
        }
        treeList.unshift(buildingGroup);
        setTreeList(treeList);
        // let r1Groups = treeList?.filter(item => !item?.parentUuid) || []
        // setGroupsR1(r1Groups);
    }, [groups])

    // useEffect(() => {
    //     setCurrentSpaceRx(null);
    //     if (!currentSpaceR1) {
    //         setGroupsRx([]);
    //         return;
    //     }
    //     let g = groups.filter(item => item.parentUuid === currentSpaceR1) || [];
    //     g.forEach(item => {
    //         let childs = groups.filter(child => child.parentUuid == item.uuid) || [];
    //         item.children = childs;
    //     })
    //     setGroupsRx(g)
    // }, [currentSpaceR1])

    useEffect(() => {
        return () => {
            clearHelpBox();
        }
    }, [])

    // useEffect(() => {
    //     if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
    //     clearHelpBox();
    //     let editor = graphicStore?.extraContext?.getCurrentViewEditor();
    //     if (!currentSpaceRx) return;
    //     // 添加包围盒
    //     let entities = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === currentSpaceRx?.uuid)) || [];
    //     let helpBox = drawEntitiesBoundingBox(entities);
    //     if (!helpBox) return;
    //     TnGroupContext.getInstance().currentGroupViewObj = helpBox;
    //     TnGroupContext.getInstance().drawHelpBox();
    // }, [currentSpaceRx])

    // 清除包围盒
    const clearHelpBox = () => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        if (TnGroupContext.getInstance().currentGroupViewObj) {
            TnGroupContext.getInstance().clearHelpBox(true);
            // graphicStore.extraContext.sceneContext.scene.remove(helpBoxRef.current);
            // graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        }
        TnGroupContext.getInstance().currentGroupViewObj = null;
        // helpBoxRef.current = null;
        // if (helpBoxRef.current) {
        //     graphicStore.extraContext.sceneContext.scene.remove(helpBoxRef.current);
        //     graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        // }
        // helpBoxRef.current = null;
    }

    const buildTree = (groups: Group[]) => {
        if (groups?.length === 0) return [];
        let groupMap: { [key: string]: Group } = {};
        let tree: (Group & { level?: number })[] = [];
        // 构建dict
        groups?.forEach(group => {
            groupMap[group?.uuid] = { ...group, children: [], level: 1 };
        });
        // 构建树
        groups.forEach(group => {
            const parent = groupMap[group?.parentUuid];
            if (parent) {
                parent?.children.push(groupMap[group?.uuid]);
                groupMap[group?.uuid].level = (parent?.level || 1) + 1;
            } else {
                tree.push(groupMap[group?.uuid]);
            }
        });

        return tree;
    };


    const renderTree = (nodes: Group[]) => {
        return (
            <>
                {nodes?.map(item => (
                    <>
                        <div className={classNames({
                            'space-rx-item': true,
                            'active': currentSpaceRx?.uuid == item?.uuid
                        })} onClick={() => {
                            clickRx(item)
                        }}>
                            {item?.uuid !== 'building' && <div
                                className="arrow"
                                onClick={() => {
                                    let idx = groups?.findIndex(g => item.uuid === g.uuid);
                                    groups[idx].hidden = !groups[idx].hidden;
                                    setGroups([...groups]);
                                }}
                            >
                                {item?.children?.length > 0 && <>
                                    {item?.level === 1 && !item?.hidden && <BlueDownSvg />}
                                    {item?.level === 1 && item?.hidden && <BlueLeftSvg />}
                                    {item?.level !== 1 && !item?.hidden && <GrayDownSvg />}
                                    {item?.level !== 1 && item?.hidden && <GrayLeftSvg />}
                                </>}
                            </div>}
                            <div className={classNames({
                                "name": true,
                                "blue-big": item?.level === 1,
                                "black-middle": item?.level === 2,
                                "gray-middle": item?.level === 3,
                            })}>{item?.name || ''}</div>
                        </div>
                        {!item?.hidden && item?.children?.length > 0 && (
                            <div style={{
                                paddingLeft: item?.level * 8,
                                width: '100%',
                            }} >
                                {renderTree(item.children)}
                            </div>
                        )}
                    </>
                ))
                }
            </>
        );
    };

    const clearState = () => {
        // setGroupsR1([]);
        // setGroupsRx([]);
        // setCurrentSpaceR1(null);
        setCurrentSpaceRx(null);
    }

    const onProcessEscape = () => {
        setCurrentSpaceRx(null);
        clearHelpBox();
    }

    const onCreateHelpBoxFinish = (curGroup: Group) => {
        let newGroupRx = groups?.find(item => item.uuid === curGroup.uuid) || null;
        setCurrentSpaceRx(newGroupRx);
    }

    const clickRx = (gRx: Group) => {
        setCurrentSpaceRx(gRx);
        const editor = graphicStore?.extraContext?.getCurrentViewEditor();
        if (!editor) return;
        if (gRx.uuid === 'building') {
            // 点击这里，显示整楼
            editor.renderControl.addObjects([RenderGroupType.building]);
            clearHelpBox();
            return;
        }
        if (gRx.level === 1) {
            // 点击这里，只显示这个一级的图元
            editor.renderControl.addObjects([gRx?.uuid]);
            clearHelpBox();
            return;
        }
        let rootGroup = findRootGroup(gRx?.uuid);
        editor.renderControl.addObjects([rootGroup?.uuid]);
        clearHelpBox();
        // 添加包围盒
        let entities = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === gRx?.uuid)) || [];
        let helpBox = drawEntitiesBoundingBox(entities);
        if (!helpBox) return;
        TnGroupContext.getInstance().currentGroupViewObj = helpBox;
        TnGroupContext.getInstance().drawHelpBox(true);
    }

    // 获取最祖上的组
    const findRootGroup = (groupUuid: string) => {
        // 构建dict
        let groupMap: { [key: string]: Group } = {};
        groups?.forEach(group => {
            groupMap[group.uuid] = group;
        });
        let currentGroup = groupMap[groupUuid];
        if (!currentGroup) return null;

        while (currentGroup?.parentUuid) {
            const parentGroup = groupMap[currentGroup?.parentUuid];
            if (!parentGroup) break;
            currentGroup = parentGroup;
        }
        return currentGroup;
    }

    return (
        <div className='space-range-container'>
            {/* <div className='space-r1-wrap'>
                <div className='space-r1-panel'>
                    <div className={classNames({
                        'space-r1-item': true,
                        'active': !!!currentSpaceR1,
                        'building': true,
                    })} onClick={() => {
                        setCurrentSpaceR1(null)
                        // 点击这里，显示整楼
                        const editor = graphicStore?.extraContext?.getCurrentViewEditor();
                        if (!editor) return;
                        editor.renderControl.addObjects([RenderGroupType.building]);

                    }}><span>整楼</span></div>
                    {groupsR1.map((group, index) => (
                        <div key={index} className={classNames({
                            'space-r1-item': true,
                            'active': currentSpaceR1?.uuid === group?.uuid
                        })} onClick={() => {
                            setCurrentSpaceR1(group)
                            // 点击这里，只显示这个一级的图元
                            const editor = graphicStore?.extraContext?.getCurrentViewEditor();
                            if (!editor) return;
                            editor.renderControl.addObjects([group?.uuid]);

                        }}><span>{group?.name || ''}</span></div>
                    ))}
                </div>
            </div> */}
            <div className='space-rx-wrap'>
                {/* {currentSpaceR1 && renderTree(currentSpaceR1?.children)} */}
                {renderTree(treeList)}
            </div>
        </div>
    )
}
